import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-formatted-text-preview',
    template: `
    <div class="formatted-text-preview ql-container ql-snow">
      <div class="ql-editor" [innerHTML]="safeHtml"></div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
    }
    .formatted-text-preview.ql-container.ql-snow {
      border: none;
      font-family: inherit;
      width: 100%;
      height: auto;
    }
    .formatted-text-preview .ql-editor {
      padding: 0;
      height: auto;
      min-height: unset;
      background: transparent;
      font-family: inherit;
      overflow-y: visible;
    }
  `],
    standalone: false
})
export class FormattedTextPreviewComponent implements OnInit, OnChanges {
  @Input() content: string = '';
  safeHtml: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.updateSafeHtml();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content']) {
      this.updateSafeHtml();
    }
  }

  private updateSafeHtml(): void {
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.content || '');
  }
}
